export default __webpack_public_path__ + "static/media/info.f2e9402e.svg";